import { EAnimationModifiers } from '@Core/Animation/SpineWrapperEventManager';
import { SPECIAL_GAME_MODE_FLAGS } from '@GFTypes/GameStoreTypes/SpecialGames';
import { getAllEventModifiers } from '@Core/Utils/ModifierUtils';
import { GameStore } from '@GameStore/GameStore';
import { IModifier } from './Modifier';

export class BaseGameModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return getAllEventModifiers(name).includes(EAnimationModifiers.BASE_GAME);
    }

    public requirementCheck(name: string): boolean {
        return !SPECIAL_GAME_MODE_FLAGS.values().some((storeKey) => this.gameStore.get(storeKey));
    }
}
